import { Button, Group, Stack, Text, TextInput } from '@mantine/core';
import { useForm } from '@mantine/form';
import React from 'react';

import { DeviceType } from '@portals/api/organizations';
import { ModalCenteredMediaLayout } from '@portals/core';

import { ModalProps } from '../components/Modals';
import { DeviceContextType } from '../route-modals';

export interface EditDeviceInfoModalProps
  extends ModalProps<{
    device: DeviceType;
    onUpdate: DeviceContextType['onUpdateDevice'];
  }> {}

export function EditDeviceInfoModal({
  data,
  closeMe,
}: EditDeviceInfoModalProps) {
  const { device, onUpdate } = data;

  const form = useForm({
    initialValues: {
      name: device.name || '',
    },
  });

  const onSubmit = (values: typeof form.values) => {
    if (values.name === device.name) {
      closeMe();
    } else {
      onUpdate({ name: values.name }, { onSuccess: closeMe });
    }
  };

  return (
    <ModalCenteredMediaLayout opened onClose={closeMe}>
      <Stack align="center" spacing="md">
        <Text size="xl" color="blue_gray.9">
          Edit device details
        </Text>

        <form onSubmit={form.onSubmit(onSubmit)} style={{ width: '100%' }}>
          <Stack>
            <TextInput
              {...form.getInputProps('name')}
              label="Device name"
              placeholder="Change device name"
              required
            />

            <Group grow pt="md">
              <Button variant="default" onClick={closeMe}>
                Cancel
              </Button>

              <Button type="submit" disabled={!form.values.name}>
                Save
              </Button>
            </Group>
          </Stack>
        </form>
      </Stack>
    </ModalCenteredMediaLayout>
  );
}
